export function getDefaultPayPalOptions() {
  return {
    clientId: window.config.PAY_PAL_CLIENT_ID,
    components: 'buttons',
    intent: 'subscription',
    vault: true,
  }
}
